import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import useDesignSystemStore, {
  GenerationStatus,
} from "@/store/zustand/aiDesignSystemBuilder";
import { PlusIcon } from "lucide-react";
import React from "react";

const ActionsMenu = () => {
  const status = useDesignSystemStore((state) => state.generation.status);
  const reset = useDesignSystemStore((state) => state.resetGeneration);
  const createGenerationForNewStory = useDesignSystemStore(
    (state) => state.createGenerationForNewStory
  );

  const inProgress = status !== GenerationStatus.Pending;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <PlusIcon className="h-4 w-4 hover:text-secondary-800 cursor-pointer" />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56">
        <DropdownMenuLabel>Actions</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuItem
            disabled={inProgress}
            onClick={createGenerationForNewStory}
          >
            <span>Create new story</span>
          </DropdownMenuItem>
          <DropdownMenuItem disabled={true}>
            <span>Add to existing story</span>
          </DropdownMenuItem>
          <DropdownMenuItem disabled={!inProgress} onClick={reset}>
            <span>Reset</span>
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default React.memo(ActionsMenu);
